import React, { useState } from 'react';
import { db } from '../firebase/firebase';
import { doc, updateDoc } from 'firebase/firestore';
import '../styles/CategoryManager.css'; // Import custom styles if necessary

export default function CategoryManager({ cardId, initialCategories }) {
    const [categories, setCategories] = useState(initialCategories || []);
    const [categoryName, setCategoryName] = useState("");
    const [limit, setLimit] = useState("");

    const addCategory = async () => {
        if (!categoryName || !limit) {
            alert("Please provide both category name and limit.");
            return;
        }
        const newCategory = { name: categoryName, limit: parseFloat(limit), spent: 0 };
        const updatedCategories = [...categories, newCategory];

        try {
            setCategories(updatedCategories);
            const cardRef = doc(db, "cards", cardId);
            await updateDoc(cardRef, { categories: updatedCategories });
            setCategoryName("");
            setLimit("");
        } catch (error) {
            console.error("Error adding category:", error);
            alert("Failed to add category. Please try again.");
        }
    };

    const deleteCategory = async (name) => {
        const updatedCategories = categories.filter((cat) => cat.name !== name);
        try {
            setCategories(updatedCategories);
            const cardRef = doc(db, "cards", cardId);
            await updateDoc(cardRef, { categories: updatedCategories });
        } catch (error) {
            console.error("Error deleting category:", error);
            alert("Failed to delete category. Please try again.");
        }
    };

    return (
        <div className="container mt-3">
            <h2 className="text-white mb-3">Manage Categories</h2>
            <div className="list-group">
                {categories.map((cat, index) => (
                    <div key={index} className="list-group-item d-flex justify-content-between align-items-center">
                        <span>{cat.name} (Limit: Rs {cat.limit})</span>
                        <button onClick={() => deleteCategory(cat.name)} className="btn btn-danger">Delete</button>
                    </div>
                ))}
            </div>
            <form className="mt-3">
                <div className="mb-3">
                    <input type="text" className="form-control" placeholder="Category Name" value={categoryName} onChange={(e) => setCategoryName(e.target.value)} />
                </div>
                <div className="mb-3">
                    <input type="number" className="form-control" placeholder="Limit" value={limit} onChange={(e) => setLimit(e.target.value)} />
                </div>
                <button type="button" onClick={addCategory} className="btn btn-primary">Add Category</button>
            </form>
        </div>
    );
}
